






















import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Exam extends Vue {
    private loading = false;

    private pagedData = [];

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getMyFromals()
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }
}
